import StorageKey from "../model/StorageKey";
import { UnityGameObject, UnityEvent, UnityMethod } from "../model/UnityConstant";
import LoginType, { isValidLoginType } from "../model/LoginType";
import SendWalletLoginType from "./SendWalletLoginType";

function RequestLoginTypeHandler(unityContext, useLegacyWalletLoginType = false) {
    unityContext.on(UnityEvent.RequestLoginType, () => {
        const rawLoginType = localStorage.getItem(StorageKey.LONGIN_TYPE);
        const loginType = isValidLoginType(rawLoginType) ? rawLoginType : "";
        SendWalletLoginType(unityContext, loginType);
        // The older development Unity build knows the MetaMask wallet flow, but not kub_wallet.
        // Keep the stored login type so the frontend still connects to KUB Wallet.
        const unityLoginType = useLegacyWalletLoginType && loginType === LoginType.KUB_WALLET
            ? LoginType.METAMASK
            : loginType;
        unityContext.send(UnityGameObject.WebContainerListener, UnityMethod.OnReceiveRequestLoginType, unityLoginType);
    });
}

export default RequestLoginTypeHandler;
